import React, { useEffect, useState } from 'react';

import PropTypes from 'prop-types';

import { VFBanner } from '@vfgroup-oneplatform/foundation/Components';

const BusinessOverviewTab = ({ TabComponent, pageBannerProps, withPageBanner, ...tabProps }) => {
  const [isPageBannerVisible, setIsPageBannerVisible] = useState(withPageBanner);

  useEffect(() => {
    setIsPageBannerVisible(withPageBanner);
  }, [withPageBanner]);
  return (
    <>
      {withPageBanner && (
        <VFBanner
          {...pageBannerProps}
          setIsPageBannerVisible={pageBannerVisible => {
            setIsPageBannerVisible(pageBannerVisible);
          }}
        />
      )}
      <TabComponent isPageBannerVisible={isPageBannerVisible} {...tabProps} />
    </>
  );
};

BusinessOverviewTab.propTypes = {
  TabComponent: PropTypes.elementType,
  pageBannerProps: PropTypes.object,
  withPageBanner: PropTypes.bool,
};

export default BusinessOverviewTab;
